import { FormattedMessage } from 'react-intl';
import React from 'react';

export default [
  { key: '01_free_on_premise', label: <FormattedMessage id='invite.parking_types.free_onsite_parking' defaultMessage='Free onsite parking' />, index: 0 },
  { key: '02_paid_on_premise', label: <FormattedMessage id='invite.parking_types.paid_onsite_parking' defaultMessage='Paid onsite parking' />, index: 1 },
  { key: '03_free_street', label: <FormattedMessage id='invite.parking_types.free_street_parking' defaultMessage='Free street parking' />, index: 2 },
  { key: '04_metered_street', label: <FormattedMessage id='invite.parking_types.metered_street_parking' defaultMessage='Metered street parking' />, index: 3 },
  { key: '05_valet', label: <FormattedMessage id='invite.parking_types.valet' defaultMessage='Valet' />, index: 4 },
  { key: '06_nearby_lot', label: <FormattedMessage id='invite.parking_types.parking_lot' defaultMessage='Nearby parking lot' />, index: 5 }
];
